import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import MainRouter from '../Router';
import { BrowserRouter as Router } from 'react-router-dom';


// function checkWebP() {
//   return new Promise((resolve, reject) => {
//     const lossyWebp = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
//     const webp = new Image();
//     webp.onload = () => {
//       console.log('загрузил');
//       resolve('Поддерживает');
//     };
//     webp.onerror = () => {
//       reject('Не поддерживает');
//     };
//     webp.src = "data:image/webp;base64," + lossyWebp;
//   })
// }
//
//
// checkWebP()
//   .then(result => console.log(result))
//   .catch(err => console.log(err));


function App() {
  return (
    <Router>
      <div className="App">
        <div className="navigation-wrapper">
          <Header />
        </div>
        <div className="content">
          <MainRouter/>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js